import React, { Component } from 'react'

export default class WarningIcon extends Component {
  render () {
    return <i className='material-icons text-danger'>flag</i>
  }
}
